/** @format — Renders AG-UI blocks below assistant text in chat */

import React from "react";
import { getAguiComponent } from "./registry";
import { filterKnownUiComponents } from "./normalizeComponents";

export default function AguiMessageBlocks({
  uiComponents = [],
  onUiAction,
  disabled,
  className = "mt-3 space-y-3 min-w-0 w-full max-w-full overflow-visible",
}) {
  const blocks = filterKnownUiComponents(uiComponents);
  if (!blocks.length) return null;

  return (
    <div className={className}>
      {blocks.map((block) => {
        const Component = getAguiComponent(block.name);
        if (!Component) return null;
        return (
          <div key={block.id ?? block.name} className="min-w-0">
            <Component
              componentId={block.id}
              props={block.props ?? {}}
              onAction={onUiAction}
              disabled={disabled}
            />
          </div>
        );
      })}
    </div>
  );
}
